import { Component, OnInit } from '@angular/core';
import { ConnectionService } from 'ng-connection-service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

export enum AutoCompleteType {
    City = 0,
    Province = 1
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    status = 'ONLINE';
    isConnected = true;
    constructor(
        private connectionService: ConnectionService,
        private toastr: ToastrService,
        private router: Router
    ) {
        this.connectionService.monitor().subscribe(isConnected => {
            this.isConnected = isConnected;
            if (this.isConnected) {
                this.status = 'ONLINE';
                console.log('Online system');
                this.toastr.clear();
                this.toastr.info('Connessione ristabilita.', 'Avviso', {
                    closeButton: true,
                    disableTimeOut: true,
                    tapToDismiss: false
                });
            } else {
                this.status = 'OFFLINE';
                this.toastr.error('Connessione internet mancante.', 'Errore', {
                    closeButton: true,
                    disableTimeOut: true,
                    tapToDismiss: false
                });
                console.log('Offline system');
            }
        });
    }

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts